import { MARKETPLACE_TO_STORE_PAGE_URL_PREFIX_LOOKUP } from "../../../utils/marketplaceConstants";

const storePagePrefixes: Record<string, string | undefined> = MARKETPLACE_TO_STORE_PAGE_URL_PREFIX_LOOKUP;

/** A seller ID linking to its Amazon storefront in `marketplace`, or plain text where there is none. */
export function SellerIdLink({ sellerId, marketplace }: { sellerId: string; marketplace: string | undefined }) {
  const prefix = marketplace && storePagePrefixes[marketplace];
  if (!prefix) {
    return <>{sellerId}</>;
  }
  return (
    <a href={`${prefix}${sellerId}`} target="_blank" rel="noreferrer">
      {sellerId}
    </a>
  );
}
